// src/components/SeriesMenu.jsx
import { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function SeriesMenu({
                                       title,
                                       items,
                                       defaultOpen = false,
                                       onNavigate,
                                       // neue Props
                                       titleImage,
                                       titleImageAlt,
                                       inactive = false,

                                       // alte Props (damit dein bisheriger Code weiter funktioniert)
                                       titleImg,
                                       titleImgAlt,
                                   }) {
    const location = useLocation();

    // Bild-Quelle zusammenführen: erst neue Props, sonst alte
    const imageSrc = titleImage || titleImg;
    const imageAlt = titleImageAlt || titleImgAlt || title;

    const anyChildActive = useMemo(() => {
        const allPaths = collectPaths(items);
        return allPaths.some((p) => location.pathname.startsWith(p));
    }, [location.pathname, items]);

    const [open, setOpen] = useState(anyChildActive || defaultOpen);

    useEffect(() => {
        if (anyChildActive) setOpen(true);
    }, [anyChildActive]);

    const toggle = () => {
        if (inactive) return;          // inaktive Serie: nichts tun
        setOpen((v) => !v);
    };

    return (
        <div className={`series ${inactive ? "series--inactive" : ""}`}>
            {/* Kopfzeile */}
            <button
                className={`series-head ${inactive ? "series-head--inactive" : ""}`}
                onClick={toggle}
                type="button"
                aria-expanded={open}
                disabled={inactive}
            >
                {imageSrc ? (
                    <img
                        src={imageSrc}
                        alt={imageAlt}
                        className="series-title-img"
                    />
                ) : (
                    <span>{title}</span>
                )}

                {!inactive && (
                    <svg
                        className={`chev ${open ? "open" : ""}`}
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M7 10l5 5 5-5"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </svg>
                )}
            </button>

            {/* Inhalt nur, wenn aktiv + geöffnet */}
            {!inactive && open && (
                <div className="series-items">
                    {items.map((it, idx) =>
                        it.isGroup ? (
                            <Group key={idx} node={it} onNavigate={onNavigate} />
                        ) : (
                            <NavLink
                                key={idx}
                                to={it.to}
                                className="nav-a"
                                onClick={onNavigate}
                            >
                                <span>{it.label}</span>
                            </NavLink>
                        )
                    )}
                </div>
            )}
        </div>
    );
}

function Group({ node, onNavigate }) {
    const location = useLocation();
    const paths = collectPaths(node.children || []);
    const hasActive = paths.some((p) => location.pathname.startsWith(p));
    const [open, setOpen] = useState(hasActive);

    useEffect(() => {
        if (hasActive) setOpen(true);
    }, [hasActive]);

    const toggle = () => setOpen((v) => !v);

    return (
        <div className="nav-group">
            <button className="nav-a nav-a--group" onClick={toggle} type="button">
                <span>{node.label}</span>
                <svg
                    className={`chev ${open ? "open" : ""}`}
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M7 10l5 5 5-5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            </button>

            {open && (
                <div className="nav-subgroup">
                    {(node.children || []).map((c, i) => (
                        <NavLink key={i} to={c.to} className="nav-a" onClick={onNavigate}>
                            <span>    {c.label}</span>
                        </NavLink>
                    ))}
                </div>
            )}
        </div>
    );
}

function collectPaths(items) {
    const out = [];
    for (const it of items) {
        if (it?.to) out.push(it.to);
        if (it?.children) {
            for (const c of it.children) if (c?.to) out.push(c.to);
        }
    }
    return out;
}
